import { CrawlerDetail } from 'types/crawlerDetail';
import { CrawlerReleasedChannel } from 'constants/crawlerReleasedChannel';
import {
  CrawlerDetailAddPayload,
  CrawlerDetailEditPayload,
} from 'api/crawlerApi';
import { CrawlerRegistrationFormFields } from './crawlerRegistrationFormFields';

/**
 * クローラーバージョン情報フォーム
 */
export type CrawlerDetailFormFields = Pick<
  CrawlerRegistrationFormFields,
  | 'version'
  | 'description'
  | 'releasedAt'
  | 'adhocSupportedIntervals'
  | 'configTemplate'
  | 'releasedChannel'
>;

export const createCrawlerDetailFormFields = ({
  version = '',
  description = '',
  releasedAt = null,
  adhocSupportedIntervals = [],
  configTemplate = '',
  releasedChannel = [],
}: Partial<CrawlerDetailFormFields>): CrawlerDetailFormFields => ({
  version,
  description,
  releasedAt,
  adhocSupportedIntervals,
  configTemplate,
  releasedChannel,
});

export const mapCrawlerDetailToFormFields = ({
  version = '',
  description = '',
  releasedAt = '',
  adhocSupportedIntervals = [],
  configTemplate = '',
  stable = false,
  beta = false,
}: Partial<CrawlerDetail>): CrawlerDetailFormFields => {
  const releasedChannel: CrawlerReleasedChannel[] = [];
  if (stable) {
    releasedChannel.push('stable');
  }
  if (beta) {
    releasedChannel.push('beta');
  }

  return {
    version,
    description,
    releasedAt: releasedAt ? new Date(releasedAt) : null,
    adhocSupportedIntervals,
    configTemplate,
    releasedChannel,
  };
};

export const mapFormFieldsToCrawlerDetailAddPayload = ({
  version,
  description,
  releasedAt,
  adhocSupportedIntervals,
  configTemplate,
  releasedChannel,
}: CrawlerDetailFormFields): CrawlerDetailAddPayload => ({
  version,
  description,
  releasedAt: releasedAt instanceof Date ? releasedAt?.toISOString() : '',
  adhocSupportedIntervals,
  configTemplate,
  stable: releasedChannel.includes('stable'),
  beta: releasedChannel.includes('beta'),
});

export const mapFormFieldsToCrawlerDetailEditPayload = ({
  description,
  releasedAt,
  adhocSupportedIntervals,
  configTemplate,
  releasedChannel,
}: CrawlerDetailFormFields): CrawlerDetailEditPayload => ({
  description,
  releasedAt: releasedAt instanceof Date ? releasedAt?.toISOString() : '',
  adhocSupportedIntervals,
  configTemplate,
  stable: releasedChannel.includes('stable'),
  beta: releasedChannel.includes('beta'),
});
